import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

// Centralised SEO: title, meta, canonical, Open Graph, Twitter, and JSON-LD.
export default function Seo({ title, description, canonical, image, jsonLd = [], noindex = false }) {
    // Direct DOM manipulation for canonical + robots (React Helmet unreliable for link tags in SPA)
    useEffect(() => {
        let link = document.querySelector('link[rel="canonical"]');
        if (canonical) {
            if (!link) {
                link = document.createElement("link");
                link.setAttribute("rel", "canonical");
                document.head.appendChild(link);
            }
            link.setAttribute("href", canonical);
        } else if (link) {
            link.remove();
        }

        let meta = document.querySelector('meta[name="robots"]');
        if (!meta) {
            meta = document.createElement("meta");
            meta.setAttribute("name", "robots");
            document.head.appendChild(meta);
        }
        meta.setAttribute("content", noindex ? "noindex, follow" : "index, follow, max-image-preview:large");
    }, [canonical, noindex]);

    return (
        <Helmet prioritizeSeoTags>
            <html lang="fr" />
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="IGN Services Alsace" />
            <meta property="og:locale" content="fr_FR" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            {canonical && <meta property="og:url" content={canonical} />}
            {image && <meta property="og:image" content={image} />}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            {image && <meta name="twitter:image" content={image} />}
            {jsonLd.map((data, i) => (
                <script key={i} type="application/ld+json">{JSON.stringify(data)}</script>
            ))}
        </Helmet>
    );
}
